export default __webpack_public_path__ + "static/media/popup plan 3.704179f0.png";